import { Oauthorization2Response, IAuthorizationResponse } from "./data-model";
import { BaseModel } from "../../models/base-model";
import { LOCALSTORAGE_AUTH } from "../../common/constants";
import { AuthTransfer } from "../../models/generic/auth-transfer";

export interface ILocalStorageAuthorizationData {
    getAuthorization(): Oauthorization2Response;
    setAuthorization(value: Oauthorization2Response): void;
}
export class LocalStorageAuthorizationData
    extends BaseModel<ILocalStorageAuthorizationData>
    implements ILocalStorageAuthorizationData {
    localStoredAuthorizationKey = "AuthorizationData";
    authorizationData: IAuthorizationResponse = null;
    private fullCachedData = null;
    constructor() {
        super();
        this.refresh();
    }
    refresh() {
        let cacheValue = localStorage.getItem(this.localStoredAuthorizationKey);
        if (cacheValue) {
            const data = JSON.parse(cacheValue) as Oauthorization2Response;
            this.fullCachedData = data;
            this.authorizationData = data.data;
        } 
    }
    getAuthorization(): Oauthorization2Response {
        return this.authorizationData;
    }
    setAuthorization(value: Oauthorization2Response): void {
        let json = JSON.stringify(value);
        localStorage.setItem(this.localStoredAuthorizationKey, json);
    }

    getAuthDataByKey(key) {
        return this.fullCachedData[key];
    }

    updateAuthorization(key, value) {
        Object.assign(this.fullCachedData, {
            [key]: value
        })
        this.setAuthorization(this.fullCachedData);
    }

}

export interface IAuthorizationConfigRequest {
    AuthConfig?: AuthTransfer;
}

export class LocalStoredAuthorizationConfigRequest
    implements IAuthorizationConfigRequest {
    AuthConfig?: AuthTransfer;
    constructor() {
        let cacheValue = localStorage.getItem(LOCALSTORAGE_AUTH);
        this.AuthConfig = JSON.parse(cacheValue);
    }
}